import { Col, Row, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

import { PageError } from '../../components/PageError'

import { DashboardOrderStatusCards } from './DashboardOrderStatusCards'
import { DashboardPendingItems } from './DashboardPendingItems'
import { DashboardRevenueCard } from './DashboardRevenueCard'
import { useDashboardSummary } from './useDashboardSummary'

export function Dashboard() {
  const { t } = useTranslation()
  const {
    annualRevenue,
    orderCounts,
    pendingReturnsCount,
    pendingCancellationsCount,
    isLoading,
    isError,
    refetch,
  } = useDashboardSummary()

  if (isError) return <PageError onRetry={() => void refetch()} />

  return (
    <div>
      <Typography.Title level={4}>{t('pages.dashboard.title')}</Typography.Title>
      <Row gutter={[16, 16]}>
        <Col xs={24} md={8}>
          <DashboardRevenueCard amount={annualRevenue.amount} isLoading={isLoading} />
        </Col>
      </Row>
      <Typography.Title level={5} style={{ marginTop: 24 }}>
        {t('pages.dashboard.orderCountByStatus')}
      </Typography.Title>
      <DashboardOrderStatusCards orderCounts={orderCounts} isLoading={isLoading} />
      <div style={{ marginTop: 24 }}>
        <DashboardPendingItems
          pendingReturnsCount={pendingReturnsCount}
          pendingCancellationsCount={pendingCancellationsCount}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
